module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full rounded"
  }, [_c('tinymce', {
    attrs: {
      "idEditor": "#editorOnlineRoundTable",
      "savedContent": _vm.form_data.prompt,
      "id": "editorPrompt"
    },
    on: {
      "change": _vm.requestAutoSave
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-26981a55!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/editBuild/editBuild.vue
// module id = 1350
// module chunks = 61